import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useAutoMetricParams } from "./hooks/useAutoMetricParams";
export var AutoMetricParams = function AutoMetricParams(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$params = _ref.params,
    params = _ref$params === void 0 ? {} : _ref$params;
  useAutoMetricParams(params);
  return children;
};
AutoMetricParams.propTypes = {
  params: PropTypes.any,
  children: PropTypes.node
};
export var AutoMetricParam = function AutoMetricParam(_ref2) {
  var _ref2$children = _ref2.children,
    children = _ref2$children === void 0 ? null : _ref2$children,
    name = _ref2.name,
    value = _ref2.value;
  useAutoMetricParams(useMemo(function () {
    return _defineProperty({}, name, value);
  }, [name, value]));
  return children;
};
AutoMetricParam.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  children: PropTypes.node
};